import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Switch, Route } from "react-router-dom";
import { Row, Col } from "reactstrap";

import Alerts from "./Alerts";
import SealAndTitle from "./Home/SealAndTitle";
import StaffMenu from "./Staff/StaffMenu";
import Welcome from "./Staff/Welcome";
import UpdateLitigantQuestionnaire from "./Staff/UpdateLitigantQuestionnaire";
import ApproveAttorneys from "./Staff/ApproveAttorneys";
import UpdateAttorneyInfo from "./Staff/UpdateAttorneyInfo";
import Appointment from "./User/Appointment";
import AppointmentCreate from "./Staff/AppointmentsCreate";
import UpdateLitigantInfo from "./Staff/UpdateLitigantInfo";
import Footer from "./Home/Footer";
import courtSeal from "./Home/images/CourtSeal-no-back.png";
import userService from "../services/userService";
import "./Home/style/home.css";

const Staff = () => {
  const alert = useSelector((state) => state.alert);

  useEffect(() => {
    console.log("start");
    const interval = setInterval(() => {
      userService.refreshToken();
    }, 240000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <React.Fragment>
      <Alerts alert={alert} />
      <Row className="largeHero">
        <Col xs={12} className="opaqueHeroSection">
          <SealAndTitle courtSeal={courtSeal} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center ">
        <Col xs={10}>
          <Row>
            <Col sm={9} className="psInfo">
              <Switch>
                <Route path="/staff/UpdateLitigantQuestionnaire">
                  <UpdateLitigantQuestionnaire />
                </Route>
                <Route path="/staff/createAppointment">
                  <AppointmentCreate />
                </Route>
                <Route path="/staff/appointment">
                  <Appointment />
                </Route>
                <Route path="/staff/UpdateLitigantInfo">
                  <UpdateLitigantInfo />
                </Route>
                <Route path="/staff/ApproveAttorneys">
                  <ApproveAttorneys />
                </Route>
                <Route path="/staff/UpdateAttorneyInfo">
                  <UpdateAttorneyInfo />
                </Route>
                <Route path="/staff">
                  <Welcome />
                </Route>
              </Switch>
            </Col>
            <Col sm={3} className="litigantMenu">
              <StaffMenu />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={12}>
          <Footer ScrollLink={Link} psInfo={false} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Staff;
